<template>
  <section class="auth-section">
    <div class="row no-gutters h-100">
      <div class="col-lg-5">
        <AuthLeftPart/>
      </div>
      <div class="col-lg-6">
        <div class="right-part h-100 d-flex justify-content-center align-items-center">
          <div class="right__content">
            <h1 class="mb-3">{{ $t('forgot_password') }}</h1>
            <template v-if="!sent">
              <p class="auth__note mt-3 mb-4">{{ $t('enter_username_to_reset_password') }}</p>
              <InputGroup :label="$t('login')"
                          type="text"
                          @enter="submit()"
                          v-model="username"/>
              <ValidationError validation-id="username"/>
              <div class="form-group text-right mt-md-4 pt-3">
                <button @click="submit()"
                        :disabled="loading || !username"
                        class="btn-themed login-btn">{{ $t('send_reset_link') }}
                </button>
              </div>
              <div v-if="errors && errors.general" class="alert alert-danger py-2">
                {{ errors.general.join(', ') }}
              </div>
            </template>
            <p v-else class="auth__note mt-3 mb-4">{{ $t('password_reset_link_sent') }}</p>
            <div class="text-center mt-3 small">
              <router-link to="/login">{{ $t('signin') }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import InputGroup from "@/components/form/InputGroup"
import ValidationError from "@/components/form/ValidationError"
import AuthLeftPart from "@/components/parts/auth/AuthLeftPart.vue"
import { useStore } from "vuex"
import { computed, onMounted, ref } from "vue"

const store = useStore()

const username = ref("")
const sent = ref(false)

onMounted(() => {
  store.commit('setError', {})
})

const loading = computed(() => store.state.dom.loading)
const errors = computed(() => store.state.auth.errors)

const submit = async () => {
  try {
    await store.dispatch('forgotPassword', username.value)
    sent.value = true
  } catch (error) {
    console.error('Forgot password error:', error)
  }
}
</script>

<style lang="scss" scoped>
.login-btn {
  min-width: 200px;
  width: 100%;
}
</style>
